function getPanel(trigger) {
  return document.getElementById(trigger.getAttribute('aria-controls'));
}

function openPanel(trigger) {
  const panel = getPanel(trigger);

  if (!panel) {
    return;
  }

  const item = trigger.closest('.js-accordion-item');

  trigger.setAttribute('aria-expanded', 'true');
  if (item) {
    item.classList.add('is-open');
  }

  panel.hidden = false;
  panel.style.height = '0px';

  // Measure the natural height, then transition to it.
  const target = panel.scrollHeight;

  requestAnimationFrame(() => {
    panel.style.height = `${target}px`;
  });

  const onEnd = e => {
    if (e.propertyName !== 'height') {
      return;
    }
    panel.style.height = '';
    panel.removeEventListener('transitionend', onEnd);
  };

  panel.addEventListener('transitionend', onEnd);
}

function closePanel(trigger) {
  const panel = getPanel(trigger);

  if (!panel || trigger.getAttribute('aria-expanded') !== 'true') {
    return;
  }

  const item = trigger.closest('.js-accordion-item');

  trigger.setAttribute('aria-expanded', 'false');
  if (item) {
    item.classList.remove('is-open');
  }

  // Set an explicit height first so the transition has a starting value.
  panel.style.height = `${panel.scrollHeight}px`;

  requestAnimationFrame(() => {
    panel.style.height = '0px';
  });

  const onEnd = e => {
    if (e.propertyName !== 'height') {
      return;
    }
    panel.hidden = true;
    panel.style.height = '';
    panel.removeEventListener('transitionend', onEnd);
  };

  panel.addEventListener('transitionend', onEnd);
}

class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll('.js-accordion');

    if (!this.accordions.length) {
      return;
    }

    this.init();
  }

  init() {
    this.accordions.forEach(accordion => {
      const closeOthers = accordion.classList.contains('has-close-others');
      const triggers = accordion.querySelectorAll('.js-accordion-trigger');

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (closeOthers && !isOpen) {
            triggers.forEach(other => {
              if (other !== trigger) {
                closePanel(other);
              }
            });
          }

          if (isOpen) {
            closePanel(trigger);
          } else {
            openPanel(trigger);
          }
        });
      });
    });
  }
}

export default new Accordion();



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js